"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LanguageSwitcher = void 0;

var _core = require("@material-ui/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var LanguageSwitcher = function LanguageSwitcher(_ref) {
  var lang = _ref.lang,
      _onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["lang", "onChange"]);

  return /*#__PURE__*/_react.default.createElement(_core.FormControl, {
    variant: "outlined",
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_core.Select, _extends({
    labelId: "lang-select-label",
    id: "lang-select",
    value: lang,
    onChange: function onChange(e) {
      if (typeof _onChange === 'function') {
        firebase.auth().languageCode = e.target.value;

        _onChange(e.target.value);
      }
    },
    autoWidth: true
  }, props), /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    value: "en"
  }, "EN"), /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    value: "de"
  }, "DE")));
};

exports.LanguageSwitcher = LanguageSwitcher;
var _default = LanguageSwitcher;
exports.default = _default;